import { Box, styled } from '@material-ui/core';
import { STabs } from '@setvi/shared/components';
import {
  ProductDetailsTab,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CSSProperties } from 'react';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2, 2, 4),
  '&::-webkit-scrollbar': {
    display: 'none'
  }
}));
export const TabNames = {
  [ProductDetailsTabsIds.WAREHOUSE]: 'Warehouse',
  [ProductDetailsTabsIds.ASSOCIATED_RESOURCE]: 'Resources',
  [ProductDetailsTabsIds.ASSOCIATED_PRODUCTS]: 'Options and Accessories',
  [ProductDetailsTabsIds.SIMILAR_PRODUCTS]: 'Similar Products',
  [ProductDetailsTabsIds.PRODUCT_INFO]: 'Product Info',
  [ProductDetailsTabsIds.SALES_ENABLEMENT]: 'Sales Kit',
  [ProductDetailsTabsIds.ORDER_HISTORY]: 'Order History',
  [ProductDetailsTabsIds.PRODUCT_ENHANCER]: 'Product Enhancer'
};
interface ProductDetailsTabsProps {
  tabs: ProductDetailsTab[];
  currentTab: ProductDetailsTabsIds;
  orderHistoryValues: boolean;
  containerStyle?: CSSProperties;
  isRestrictedView?: boolean;
  onTabChange: (tab: ProductDetailsTabsIds) => void;
}
export const Tabs = ({
  currentTab,
  tabs = [],
  orderHistoryValues,
  containerStyle,
  isRestrictedView = false,
  onTabChange
}: ProductDetailsTabsProps) => {
  const flags = useFlags();
  const list = tabs
    .map(tab => ({
      label: TabNames[tab.id] || '-',
      value: tab.id,
      visible: () => {
        if (tab.id === ProductDetailsTabsIds.SIMILAR_PRODUCTS)
          return flags.productsSimilarProducts;

        if (tab.id === ProductDetailsTabsIds.ORDER_HISTORY)
          return flags.orders && orderHistoryValues;

        return true;
      }
    }))
    .filter(i => i.visible());

  return (
    <Container style={containerStyle}>
      <STabs
        type="rounded"
        tabsList={[
          ...list,
          ...(!isRestrictedView && flags.salesEnablement
            ? [
                {
                  label: TabNames[ProductDetailsTabsIds.SALES_ENABLEMENT],
                  value: ProductDetailsTabsIds.SALES_ENABLEMENT,
                  visible: () => flags.salesEnablement
                }
              ]
            : []),
          ...(!isRestrictedView && flags.productEnhancer
            ? [
                {
                  label: TabNames[ProductDetailsTabsIds.PRODUCT_ENHANCER],
                  value: ProductDetailsTabsIds.PRODUCT_ENHANCER,
                  visible: () => flags.productEnhancer
                }
              ]
            : [])
        ]}
        currentTab={currentTab}
        handleTabChange={onTabChange}
        divider={false}
        tabStyle={{ padding: '10px 12px' }}
      />
    </Container>
  );
};
